import { createInstance } from 'app/localforage'

const localStore = createInstance({
  name: 'strategies/local'
})

const rep = { jsonapi: { version: '1.0' } }

function makeKey(type, url) {
  return `${type}-${url}`
}

async function set({ type, url, value }) {
  if (value === null) {
    return localStore.removeItem(makeKey(type, url))
  } else {
    return localStore.setItem(makeKey(type, url), { ...rep, data: value })
  }
}

async function _default({ type, url, value }) {
  let retval = value
  const key = makeKey(type, url)
  const existing = await localStore.getItem(key)

  if (!existing) {
    retval = await localStore.setItem(key, { ...rep, data: value })
  }

  return Promise.resolve(retval)
}

export default {
  default: _default,

  set: set,

  accept: async ({ type, url, method }) => {
    if (!type || method.toLowerCase() !== 'get') return false

    return localStore.getItem(makeKey(type, url))
  },

  process: ({ preamble }) => {
    return Promise.resolve({ data: preamble })
  }
}
